export default __webpack_public_path__ + "static/titan-be8b605408cb6798aff8c4f3061c4c88.png";